import globalStore from './global-store'


export default {
  globalStore,
}